export enum ErrorCode {
  ALREADY_EXISTS = 'already-exists',
}
